import { format } from 'date-fns';

type FormatArgs = {
  data: any[];
  filter?: any;
  startDate: any;
  endDate: any;
};

const formatString = (value: any): string => {
  if (value === undefined || value === null) return '';
  return value as string;
};

const formatDate = (value: any): string => {
  if (!value) return '';
  return format(new Date(value), 'yyyy-MM-dd');
};

const formatNoLogins = (data: any): string => {
  if (!(data && data.authMetaData && data.authMetaData.length > 0)) return '';
  return data.authMetaData.length as string;
};

const formatAverageDuration = (data: any): string => {
  if (!(data && data.authMetaData && data.authMetaData.length > 0)) return '';
  let totalDuration = 0;
  data.authMetaData.forEach((d: any) => {
    if (d.duration) {
      totalDuration += d.duration;
    }
  });

  const averageDuration = totalDuration / data.authMetaData.length;

  return Math.round(averageDuration).toString();
};

const formatLastLoginDuration = (data: any): string => {
  if (!(data && data.authMetaData && data.authMetaData.length > 0)) return '';
  if (data.authMetaData[data.authMetaData.length - 1] && data.authMetaData[data.authMetaData.length - 1].duration) {
    return data.authMetaData[data.authMetaData.length - 1].duration;
  } else {
    return '';
  }
};

const getField = (field: any, field1?: string, field2?: string): any => {
  if (field === undefined || field === null) return undefined;
  if (field1 === undefined) return field;
  if (field[field1] === undefined || field[field1] === null) return undefined;
  if (field2 === undefined) return field[field1];
  if (field[field1][field2] === undefined || field[field1][field2] === null) return undefined;
  return field[field1][field2];
};

export const formatUserReportExportData = ({ data, startDate, endDate }: FormatArgs) => {
  let results: any[] = [];

  data.forEach((edge: any) => {
    const node = edge.node ? edge.node : edge;

    results.push({
      name: formatString(getField(node.firstName) + '' + getField(node.lastName)),
      email: formatString(getField(node.email)),
      designation: formatString(getField(node.designation)),
      systemRole: formatString(getField(node.registrationRole, 'name')),
      createdAt: formatDate(getField(node.createdAt)),
      status: formatString(getField(node.status)),
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      noLogins: formatNoLogins(node),
      averageDuration: formatAverageDuration(node),
      lastLoginDuration: formatLastLoginDuration(node),
    });
  });

  return results;
};
